



















































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { Comissoes } from '@/plugins/api';
import { BPopover } from 'bootstrap-vue';

@Component
export default class ReverterComissao extends Vue {
  @Prop() public readonly comissao!: IComissao;
  @Ref() public readonly popover!: BPopover;
  public processing = false;

  get popoverId(): string {
    return `reverter-comissao-${this.comissao.id}`;
  }

  get disabled(): boolean {
    if (this.processing) return true;
    return ['adicionado', 'pago'].includes(this.comissao.situacao);
  }

  dismiss(): void {
    this.$root.$emit('bv::hide::popover');
  }

  reverter(): void {
    this.dismiss();
    this.processing = true;

    const data: PatchComissaoRequest = {
      situacao: 'adicionado',
      todos: true,
    };
    Comissoes.patch(this.comissao.id, data)
      .then(() => {
        this.$emit('refresh');
      })
      .catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Falha ao reverter!',
        });
      })
      .finally(() => {
        this.processing = false;
      });
  }
}
